import {XhrFactory} from '@angular/common'
import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpXhrBackend} from '@angular/common/http'
import {Injectable, inject} from '@angular/core'
import {Observable} from 'rxjs'
import {RESPONSE_TYPE_BLOB} from '@common/global-constants'

/**
 * Interceptor que redirige las peticiones de tipo blob al backend XHR,
 * evitando los problemas de compatibilidad entre withFetch() y responseType: RESPONSE_TYPE_BLOB.
 */
@Injectable()
export class BlobXhrInterceptor implements HttpInterceptor {
  private readonly xhrBackend = new HttpXhrBackend(inject(XhrFactory))

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (req.responseType !== RESPONSE_TYPE_BLOB) {
      return next.handle(req)
    }

    return this.xhrBackend.handle(req)
  }
}
